import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
  name: 'removeAsteristicoUnderline',
})
export class RemoveAsteristicoUnderlinePipe implements PipeTransform {
  removedorAsteristico = /(\*+)/g;
  stringComAsteristico: any;
  transform(value: any) {
    if (!value) {
      return value;
    }

    this.stringComAsteristico = value;
    return this.removerAsterisco(this.stringComAsteristico, this.removedorAsteristico);
  }

  removerAsterisco(stringComAsteristico: any, removedorAsteristico: any) {
    return stringComAsteristico.replace(removedorAsteristico, '').replace('_', '');
  }
}
